import React from 'react';
import Icon from '../../../components/AppIcon';

const KPICards = ({ language, metrics }) => {
  const content = {
    en: {
      totalRevenue: 'Total Revenue',
      activeOrders: 'Active Orders',
      avgResponseTime: 'Avg Response Time',
      satisfaction: 'Customer Satisfaction',
      hours: 'hours',
      noData: 'No data available'
    },
    zh: {
      totalRevenue: '总收入',
      activeOrders: '活跃订单',
      avgResponseTime: '平均响应时间',
      satisfaction: '客户满意度',
      hours: '小时',
      noData: '暂无数据'
    }
  };

  const t = content?.[language];

  const kpiData = [
    {
      id: 1,
      label: t?.totalRevenue,
      value: metrics?.totalRevenue ? `$${Number(metrics?.totalRevenue)?.toLocaleString()}` : '$0',
      icon: 'DollarSign',
      color: 'primary',
      trend: '+12%'
    },
    {
      id: 2,
      label: t?.activeOrders,
      value: metrics?.totalOrders || 0,
      icon: 'ShoppingCart',
      color: 'secondary',
      trend: '+8%'
    },
    {
      id: 3,
      label: t?.avgResponseTime,
      value: metrics?.avgResponseHours ? `${Number(metrics?.avgResponseHours)?.toFixed(1)} ${t?.hours}` : `0 ${t?.hours}`,
      icon: 'Clock',
      color: 'accent',
      trend: '-15%'
    },
    {
      id: 4,
      label: t?.satisfaction,
      value: metrics?.avgRating ? `${Number(metrics?.avgRating)?.toFixed(1)}/5` : '0/5',
      icon: 'Star',
      color: 'success',
      trend: '+5%'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      primary: 'bg-primary/10 text-primary',
      secondary: 'bg-secondary/10 text-secondary',
      accent: 'bg-accent/10 text-accent-foreground',
      success: 'bg-success/10 text-success'
    };
    return colors?.[color] || colors?.primary;
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {kpiData?.map((kpi) => (
        <div key={kpi?.id} className="bg-card border border-border rounded-lg p-6">
          <div className="flex items-start justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${getColorClasses(kpi?.color)}`}>
              <Icon name={kpi?.icon} size={24} />
            </div>
            {kpi?.trend && (
              <span className={`text-xs font-medium px-2 py-1 rounded ${
                kpi?.trend?.startsWith('+') ? 'bg-success/10 text-success' : 'bg-destructive/10 text-destructive'
              }`}>
                {kpi?.trend}
              </span>
            )}
          </div>
          <h3 className="text-2xl font-bold text-foreground mb-1">{kpi?.value}</h3>
          <p className="text-sm text-muted-foreground">{kpi?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default KPICards;